module.exports = __webpack_public_path__ + "static/img/附件五.e224045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件五.jpg
// module id = 0mYD
// module chunks = 1